import React, { Component } from 'react'
import { connect } from 'react-redux'

function mapStateToProps(state, hocProps) {
    const { module, id, block } = hocProps

    return {
        selector: state.getIn(['ui', 'workspace', module, id, 'blocks', block, 'customData', 'selector']),
    }
}

export default function (InnerComponent) {
    @connect(mapStateToProps, null)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
